<template>
  <div class="card mr-2">
    <div
      class="header border-bottom accordian-toggle"
      v-b-toggle.idReverification
      @click="handleToggle"
    >
      <h5 class="text-primary font-weight-normal mb-0">ID Reverification</h5>
    </div>
    <b-collapse id="idReverification">
      <div class="body">
        <!-- Loading State -->
        <div v-if="!loaded" class="text-center py-3">
          <b-spinner small variant="primary"></b-spinner>
          <span class="ml-2 text-muted">Loading...</span>
        </div>

        <!-- Content -->
        <div v-else>
          <!-- Status Row -->
          <div class="d-flex justify-content-between align-items-center mb-3">
            <span
              class="badge" 
              :class="
                config.requireIdReverification
                  ? 'badge-danger'
                  : 'badge-success'
              "
            >
              {{ config.requireIdReverification ? "Enabled" : "Disabled" }}
              
            </span>
            <b-button
              v-if="!config.requireIdReverification"
              variant="primary"
              size="sm"
              @click="handleEnable"
            >
              <i class="fa fa-exclamation-triangle mr-1"></i>
              Enable Reverification
            </b-button>
            <b-button
              v-else
              variant="secondary"
              size="sm"
              @click="handleDisable"
            >
              <i class="fa fa-times mr-1"></i>
              Disable Reverification
            </b-button>
          </div>

          <div v-if="!config.requireIdReverification" class="text-muted small">
            <i class="fa fa-info-circle mr-1"></i>
            No ID reverification is currently required for this customer.
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { ISLOADING } from "@/store/mutations.type";
import {
  GET_ID_REVERIFICATION_CONFIG,
  UPDATE_ID_REVERIFICATION_CONFIG,
} from "@/store/actions.type.js";
import { myFunction } from "@/common/common-helper.js";

export default {
  name: "IdReverification",
  props: {
    customerId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loaded: false,
      config: {
        requireIdReverification: false,
      },
    };
  },
  methods: {
    async handleToggle() {
      if (this.loaded) return;
      await this.loadConfig();
    },

    async loadConfig() {
      try {
        const response = await this.$store.dispatch(
          GET_ID_REVERIFICATION_CONFIG,
          this.customerId,
        );
        if (response.status === 200) {
          this.config = response.data.details;
        }
      } catch {
        myFunction.showInfo("Failed to load ID reverification config", "error");
      } finally {
        this.loaded = true;
      }
    },

    async handleEnable() {
      const result = await this.$swal.fire({
        title: "Enable ID Reverification",
        text: "Are you sure you want to enable ID reverification for this customer?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Enable",
        cancelButtonText: "Cancel",
        customClass: {
          confirmButton: "btn btn-primary btn-lg my-3",
          cancelButton: "btn btn-outline-secondary btn-lg",
        },
        buttonsStyling: false,
      });

      if (!result.isConfirmed) return;

      this.$store.commit(ISLOADING, true);

      try {
        const response = await this.$store.dispatch(
          UPDATE_ID_REVERIFICATION_CONFIG,
          {
            customerId: this.customerId,
            requireIdReverification: true,
          },
        );

        if (response.status === 200) {
          myFunction.showInfo("ID reverification enabled successfully", "success");
          this.loaded = false;
          await this.loadConfig();
        } else {
          myFunction.showInfo(response.data?.message || "An error occurred", "error");
        }
      } catch {
        myFunction.showInfo("An error occurred", "error");
      } finally {
        this.$store.commit(ISLOADING, false);
      }
    },

    async handleDisable() {
      const result = await this.$swal.fire({
        title: "Disable ID Reverification",
        text: "Are you sure you want to disable ID reverification for this customer?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Disable",
        cancelButtonText: "Cancel",
        customClass: {
          confirmButton: "btn btn-primary btn-lg my-3",
          cancelButton: "btn btn-outline-secondary btn-lg",
        },
        buttonsStyling: false,
      });

      if (!result.isConfirmed) return;

      this.$store.commit(ISLOADING, true);

      try {
        const response = await this.$store.dispatch(
          UPDATE_ID_REVERIFICATION_CONFIG,
          {
            customerId: this.customerId,
            requireIdReverification: false,
          },
        );

        if (response.status === 200) {
          myFunction.showInfo("ID reverification disabled successfully", "success");
          this.loaded = false;
          await this.loadConfig();
        } else {
          myFunction.showInfo(response.data?.message || "An error occurred", "error");
        }
      } catch {
        myFunction.showInfo("An error occurred", "error");
      } finally {
        this.$store.commit(ISLOADING, false);
      }
    },
  },
};
</script>
